// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-icon[data-v-11a717fe]{width:6rem;height:6rem;cursor:pointer;border-radius:1rem;padding:.5rem}.app-icon[data-v-11a717fe]:hover{background:#eee}.icon[data-v-11a717fe]{width:3rem;height:3rem}.icon>svg[data-v-11a717fe]{height:100%;width:100%}", ""]);
// Exports
module.exports = exports;
